import { FormsService } from "./../../../services/forms/forms.service";

import { ChangeSaveProgressSettingsActionType } from "./../types";
import { getChangedFormSaveProgressSettings } from "./../../../helpers/dataManipulations";

export function* changeSaveProgressSettingsSaga({ payload }: ChangeSaveProgressSettingsActionType) {
    try {
        yield FormsService.newUpdateForm({
            data: getChangedFormSaveProgressSettings(payload.prevState, payload.currentState),
        });
    } catch (error) {
        // yield put(Handle Error);
    }
}
